import { useNewRequestContext } from "./";

export const useNewRequest = () => {
  const { state, dispatch } = useNewRequestContext();
  return {
    state,
    setSampleDetailsForm: (sampleDetailsForm) =>
      dispatch({ type: "set-sample-details-form", sampleDetailsForm }),
    setItemList: (itemList) => dispatch({ type: "set-item-list", itemList }),
    setSampleRequestDetails: (sampleRequestDetails) =>
      dispatch({
        type: "set-resubmit-sample-request-details",
        sampleRequestDetails,
      }),
    setIsSubmitting: (isSubmitting) =>
      dispatch({ type: "set-is-submitting", isSubmitting }),
    setSampleRequestFormDisplay: (sampleRequestFormDisplay) =>
      dispatch({
        type: "set-sample-request-form-display",
        sampleRequestFormDisplay,
      }),
    setItemFormDisplay: (itemFormDisplay) =>
      dispatch({
        type: "set-item-form-display",
        itemFormDisplay,
      }),
    setItemFormToEdit: (itemFormToEdit) =>
      dispatch({
        type: "set-item-form-to-edit",
        itemFormToEdit,
      }),
  };
};
